import { GuestDto, MemberRoleDto, TenantDto, UserDto } from '@nusign/picflow-backend-types';

import { Injectable, signal } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AuthToken } from '../classes/authToken';
import { RecurringInterval } from '../types/product.type';

@Injectable({
  providedIn: 'root',
})
export class StateService {
  public nextPageIsNotFound: boolean;
  public impersonating: boolean;
  public user: UserDto;
  public user$ = new BehaviorSubject<UserDto>(undefined);
  public tokenData: AuthToken;
  public tokenData$ = new BehaviorSubject<AuthToken>(undefined);
  public tenants: TenantDto[];
  public tenants$ = new BehaviorSubject<TenantDto[]>([]);
  public activeTenant$ = new BehaviorSubject<TenantDto>(undefined);
  public activeTenantRole: MemberRoleDto | 'shared';

  public guest: GuestDto;
  public guestAuthToken: string;
  public preGuestAnonymousId: string;
  public renewGuestAuthToken = async () => console.error('Guest-auth service not loaded');
  public visitingTenant$ = new BehaviorSubject<TenantDto>(undefined); // gallery view pages

  public unseenActivity = 0;
  public unseenActivityCountMap: Map<string, number> = new Map();

  public billingFrequency = signal<RecurringInterval>('year');

  public galleryPreviewMode = false;
  public galleryPreviewModeIdentified = false;
  public loggingOut = signal(false);

  public showingNonPaymentBanner = signal(false);
  public readonly temporarilyHideNonPaymentBanner = signal(false);
}
